import { Award, HeartHandshake, Sparkles } from "lucide-react";

const SALON_IMG =
  "https://static.prod-images.emergentagent.com/jobs/e65e354b-d9a2-449a-9e1d-ca9880f3773c/images/42f5e5a6071accca5a07172f3af4b79b45ca87d1f9a8b7f4aa51ae6731ca40aa.png";

const benefits = [
  {
    icon: HeartHandshake,
    title: "Atendimento Personalizado",
    desc: "Cada cliente é única. Diagnóstico, escuta e planejamento exclusivos para o seu cabelo.",
  },
  {
    icon: Award,
    title: "Profissional Experiente",
    desc: "Mais de uma década dedicada à arte capilar. Técnicas avançadas, produtos premium.",
  },
  {
    icon: Sparkles,
    title: "Resultados Visíveis",
    desc: "Fios mais fortes, hidratados e alinhados já na primeira visita. Autoestima lá em cima.",
  },
];

export default function Benefits() {
  return (
    <section
      id="beneficios"
      data-testid="benefits-section"
      className="relative py-24 md:py-32 bg-gradient-to-b from-[#050505] via-[#0a0a0a] to-[#050505]"
    >
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        <div className="relative order-2 lg:order-1">
          <div className="absolute -top-4 -left-4 w-full h-full border border-[#D4AF37]/30 z-0" />
          <img
            src={SALON_IMG}
            alt="Estúdio EZ Capelli"
            data-testid="benefits-image"
            className="relative z-10 w-full h-[500px] object-cover grayscale-[15%]"
          />
          <div className="absolute -bottom-6 -right-6 bg-[#D4AF37] text-[#050505] p-6 z-20 max-w-[200px]">
            <div className="font-heading text-4xl font-light">10+</div>
            <div className="text-xs uppercase tracking-[0.2em] font-semibold">
              Anos transformando cabelos
            </div>
          </div>
        </div>

        <div className="order-1 lg:order-2">
          <span className="overline" data-testid="benefits-overline">
            Por que EZ Capelli
          </span>
          <h2
            data-testid="benefits-title"
            className="font-heading text-4xl md:text-5xl font-light tracking-tight mt-4 text-white"
          >
            Mais que um salão. <br />
            Uma <span className="gold-gradient-text italic">experiência</span>.
          </h2>
          <div className="gold-line w-24 mt-6 mb-10" />

          <div className="space-y-10">
            {benefits.map((b, i) => {
              const Icon = b.icon;
              return (
                <div
                  key={b.title}
                  data-testid={`benefit-${i}`}
                  className="flex gap-5 items-start group"
                >
                  <div className="flex-shrink-0 w-14 h-14 border border-[#D4AF37]/30 flex items-center justify-center group-hover:bg-[#D4AF37]/10 transition-colors">
                    <Icon size={22} strokeWidth={1.25} className="text-[#D4AF37]" />
                  </div>
                  <div>
                    <h3 className="font-heading text-xl md:text-2xl font-medium text-white">
                      {b.title}
                    </h3>
                    <p className="text-sm md:text-base text-white/60 font-light mt-2 leading-relaxed">
                      {b.desc}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
